import FeedbackPage from '@/components/FeedbackPage'
import { getTopicsFeedback } from '@/utils/feedbackContent'

export default function TopicsFeedbackPage() {
  return <FeedbackPage {...getTopicsFeedback()} />
}
